export const tooltipDynamicPricing = {
  kwhPrice:
    'Price calculation based on the energy of the transaction. For example: R$ 2.00/kWh',
  durationPrice:
    'Price calculation based on the duration of the transaction. For example: R$ 1.00/minute.',
  servicePrice: 'Flat price per start. For example: R$ 5.00/start.',
  idleTimePrice:
    // eslint-disable-next-line quotes
    "Price based on the duration of the charger's idle time, i.e., the period after the transaction ends when the vehicle remains connected and occupying the charger (finishing state). For example: R$ 5.00/minute of finishing.",
  reservePrice:
    'Flat price to use the reservation function. For example: R$ 5.00/reservation.',
  operationFee:
    'System operation fee, to be applied after integrating the charging costs. For example: The final transaction amount is R$ 100.00, and the fee is 5%, so the operation fee should add R$ 5.00 to the final charging amount.',
  taxes:
    'Tax fee, to be applied after integrating the charging costs. For example: The final transaction amount is R$ 100.00, and the tax is 15%, so the tax fee should add R$ 15.00 to the final charging amount.',
  moneyPerKilowattCost: 'Amount paid by the operator for energy consumption.',
  customIdleTime: 'Duration (in minutes) after which the idle time pricing will be applied.',
};
